import React from 'react';
import { Modal } from 'antd';
import LoginProvider from '../store/provider/LoginProvider';
import Content from './components/Content';
import { ILoginProps } from '../types';
import './index.less';


const ModalContent = ({ modal, ...props }: ILoginProps) => {

    const handleCloseModal = () => {
        modal && modal.destroy();
    }

    return (
        <LoginProvider
            { ...props }
            isModal
            handleCloseModal={ handleCloseModal }
        >
            <Content />
        </LoginProvider>
    )

}

export default function requireLoginModal(opts?) {
    
    return new Promise((resolve, reject) => {
        try {
            const { afterClose, onSuccess, ...props } = opts || {};
            const modal = Modal.info({
                centered: true,
                width: 672,
                icon: '',
                afterClose: (...params) => {
                    // 弹窗关闭了
                    afterClose && afterClose(params);
                },
            });
            const handleSuccess = (...params) => {
                onSuccess && onSuccess(params);
                resolve(params);
            }
            modal.update({
                className: 'pc-login-pop-container',
                content: <ModalContent modal={ modal } onSuccess={ handleSuccess } { ...props }/>,
            })
        } catch (error) {
            reject(error);
        }
    })
}

